import { render, staticRenderFns } from "./EventSeminar.vue?vue&type=template&id=2375537a&"
import script from "./EventSeminar.vue?vue&type=script&lang=js&"
export * from "./EventSeminar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports